import React from 'react'
import GlobalAllCamera from '../../../Screens/GlobalUser/CameraConfigurations/cameras_table';
    
const CameraStatusQA = () => {
  return <>
   <GlobalAllCamera TechDashboard={true} />
  </>
}

export default CameraStatusQA